<template>
  <div class="staff-basic">
    <c-table
      ref="table"
      :fields="fields"
      :columns="columns"
      url="/mailbackup/list"
      :fetchPage="true"
      @before-fetch="beforeFetch"
    >
      <el-table-column slot="operation" label="操作"  width="60">
        <template v-slot="{row}">
          <el-button type="text" @click="download(row)">下载</el-button>
        </template>
      </el-table-column>
    </c-table>
  </div>
</template>

<script>
import CTable from '@/components/common/table'
import mixin from '@/mixins'

export default {
  name: 'file-detail',
  mixins: [ mixin ],
  components: { CTable },
  data () {
    return {
      fields: [
        {
          prop: 'search',
          placeholder: '搜索',
          clearable: true
        }],
      columns: [
        { prop: 'subject', label: '标题', minWidth: 140 },
        { prop: 'from', label: '发件人', minWidth: 140 },
        { prop: 'to', label: '收件人', minWidth: 140 },
        { prop: 'attach', label: '附件', minWidth: 140 },
        { prop: 'time', label: '时间', width: 180 },
        { slot: 'operation' }
      ],
      dir: decodeURIComponent(location.href.split('/')[location.href.split('/').length - 1]),
      email: location.href.split('/')[location.href.split('/').length - 2]
    }
  },
  created() {
  },
  methods: {
    download (row) {
      this.$notify.success({
        title: '正在下载...',
        message: row.attach
      })
      this.$http.post(`/mailbackup/get`, {
        email: this.email,
        id: row.id
      }, {
        responseType: 'blob'
      }).then(res => {
        let link = document.createElement('a')
        let evt = document.createEvent('HTMLEvents')
        evt.initEvent('click', false, false)
        link.href = URL.createObjectURL(res.data)
        link.download = `${row.subject}.eml`
        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(link.href)
      })
    },
    beforeFetch(data) {
      if (this.email) {
        data.email = this.email
      }
      if (this.dir) {
        data.dir = this.dir
      }
    }
  }
}
</script>

<style lang="scss">
</style>
